import { render, staticRenderFns } from "./ExpensesTable.vue?vue&type=template&id=f5305fc2&scoped=true&"
import script from "./ExpensesTable.vue?vue&type=script&lang=js&"
export * from "./ExpensesTable.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ExpensesTable.vue?vue&type=style&index=1&id=f5305fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5305fc2",
  null
  
)

export default component.exports